import { useContext } from 'react'
import { VectorGridOptions, canvas } from 'leaflet'
import { buildVectorTileLayerDefaultOptions } from '../utils'
import { VectorGrid } from './VectorGrid'
import LayersContext from '../../../contexts/Layers'
import { api } from '../../../config'

const layerName = 'cadastralPlots'
const layerSource = 'cadastral_grid'
const options: VectorGridOptions = {
  zIndex: 3,
  interactive: false,
  rendererFactory: canvas.tile,
  vectorTileLayerStyles: {
    [layerSource]: {
      ...Object.values(
        buildVectorTileLayerDefaultOptions(layerName, layerSource).vectorTileLayerStyles
      )[0],
      fill: false,
    },
  },
}
const url = `${api.host}/vector_tiles/${layerSource}/{z}/{x}/{y}.pbf`

export const CadastralPlotsLayer = () => {
  const { selected } = useContext(LayersContext)

  return selected.includes(layerName) ? <VectorGrid url={url} options={options} /> : null
}
